<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { IonToggle, CheckboxCustomEvent } from '@ionic/vue'

//  name: 'FeToggle',

const props = defineProps<{
  modelValue: boolean
  label?: string
  disabled?: boolean
  reverse?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
}>()

const labelPlacement = computed(() => {
  if (!props.label) {
    return undefined
  }
  return props.reverse ? 'start' : 'end'
})

function handleToggleChange(event: CheckboxCustomEvent): void {
  const eventTarget = event.target as unknown as HTMLIonToggleElement
  change(eventTarget.checked)
}

function change(value: boolean): void {
  emit('change', value)
  emit('update:modelValue', value)
}
/**
 * Retrieves all dynamic attributes that are not defined as props for the component.
 * This includes attributes like `placeholder`, `data-test`, etc. that are passed to the component.
 * These attributes are then bound to the `ion-input` element within the component.
 * Like the old `inheritAttrs: false`
 */
const attrs = useAttrs()
</script>

<template>
  <ion-toggle
    ref="absToggle"
    v-bind="attrs"
    :label-placement="labelPlacement"
    :checked="modelValue"
    :disabled="disabled"
    @ion-change="handleToggleChange"
  >
    <span class="toggle-text">{{ label }}</span>
  </ion-toggle>
</template>

<style lang="scss" scoped>
@import '@/styles/_constants.scss';
/*
ion-item {
  --inner-border-width: 0;
  border: none;
  display: flex;
  align-items: center;
  height: 3.5rem;
  margin-bottom: 0;
  flex-direction: row-reverse;
  max-width: 24rem;
}
*/
/**/
ion-toggle {
  /* Track: thin line, light gray when off, dark gray when on */
  --track-background: #e5e5e5;
  --track-background-checked: var(--color-bg-dark-grey, #4d4d4d);
  /* Thumb: dark gray (charcoal) when off, white when on – flat, no shadow */
  --handle-background: var(--color-bg-dark-grey, #4d4d4d);
  --handle-background-checked: var(--color-bg-light, #fff);

  --handle-height: 20px;
  --handle-width: 20px;
  --handle-box-shadow: none;

  padding-left: 0;
  padding-right: 0;
  min-width: 3.6rem;
  contain: none;
  overflow: visible;
  font-size: 1.35rem;
  display: flex;
  flex-shrink: 0;

  &::part(track) {
    height: 10px;
    width: 36px;
    overflow: visible;
    border-radius: 999px;
    box-shadow: none;
  }

  &::part(handle) {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    min-width: 20px;
    min-height: 20px;
    width: 20px;
    height: 20px;
  }
}
/**/

/*
ion-label {
  margin: 0;
  text-transform: uppercase;
  cursor: pointer;
  flex: 0;
  flex-basis: auto;

  .toggle-checked + & {
    --color: rgb(var(--color-info));
  }
}
*/
</style>
